import { useEffect, useState } from 'react'
import { api } from '../../../api'

/**
 * Proposer un produit, ecran 1 : « Comment s'appelle votre produit ? »
 * (prototype v7.4, WizardOffre/prop.nom). Un champ de verre, et sous lui
 * l'anti-doublon du prototype : une ligne teal « Ça existe peut-être déjà :
 * X — l'utiliser » par produit proche (recherche catalogue, debounce 400 ms).
 * Le producteur n'est jamais bloque : s'il continue, l'admin arbitre a la
 * validation.
 */
function StepProposeName({ nom, onNomChange, onSelectExisting }) {
  const [matches, setMatches] = useState([])

  useEffect(() => {
    const trimmed = nom.trim()
    if (trimmed.length < 3) {
      setMatches([])
      return
    }
    const timer = setTimeout(() => {
      api.producer.getCatalog(trimmed)
        .then((data) => setMatches(Array.isArray(data) ? data.slice(0, 3) : []))
        .catch(() => setMatches([]))
    }, 400)
    return () => clearTimeout(timer)
  }, [nom])

  return (
    <div>
      <input
        type="text"
        value={nom}
        onChange={(e) => onNomChange(e.target.value)}
        placeholder="Ex. Prune de Cythère"
        className="w-full rounded-2xl px-[15px] py-[13px] text-base text-ink outline-none"
        style={{ background: 'rgba(255,255,255,0.6)', border: '1px solid rgba(7,62,61,0.12)' }}
      />

      {matches.map((p) => (
        <button
          key={p.id}
          onClick={() => onSelectExisting(p)}
          className="mt-2.5 w-full rounded-[14px] px-[13px] py-[11px] text-[12.5px] text-left text-ink animate-fade-up"
          style={{ border: '1px solid rgb(var(--c-teal) / 0.35)', background: 'rgb(var(--c-teal) / 0.08)' }}
        >
          💡 Ça existe peut-être déjà : <strong>{p.category?.emoji || '📦'} {p.nom}</strong> — l'utiliser
        </button>
      ))}
    </div>
  )
}

export default StepProposeName
